<template>
    <div class="employee-preference-view has-header" v-bind:class="{'group-drag' : draggingGroup}">
        <div class="header">
            <div class="fa-stack fa-header" v-on:click="Init()">
                <i class="fas fa-refresh fa-stack-2x"></i>
            </div>
            <div class="options">
                <div class="label" v-for="(displayedTimeframe, indexD) in displayedTimeframes" v-bind:class="{'selected': displayedTimeframeSelected === displayedTimeframe}" :key="indexD"
                     v-on:click="RefreshTimeFrame(displayedTimeframe)">{{displayedTimeframe.label}}</div>
            </div>
            <div class="button filter" v-on:click="OpenFilterDropdown($event)">
                <div class="label">Anzeige</div>
            </div>
            <div class="button filter" v-on:click="toggleDatePicker()">
                <div class="label">{{monthDisplay}}</div>
            </div>
        </div>
        <div class="scrollbar-container">
            <div class="grid">
                <div class="positions-filter button" v-on:click="OpenBusinessUnitFilterDropdown($event)">
                    <div class="label" style="padding-left: 3px; padding-top: 1px;">
                        <i class="fas fa-tasks"></i>
                    </div>
                </div>
                <div class="employee-filter button" v-on:click="OpenFilterPopup($event)">
                    <div class="label" style="padding-left: 4px; padding-top: 1px;">
                        <i class="fas fa-filter"></i>
                    </div>
                </div>
                <div class="backdrop"></div>
                <div class="header">
                    <div class="label">Abwesenheiten</div>
                </div>
                <div class="group" v-for="(group, indexGroup) in employeeGroups" :key="indexGroup"
                    v-if="ungroupEmployees || spotVisibilityList.find(s => s === group.spot)"
                    v-bind:indexGroup="indexGroup"
                    v-bind:class="GetGroupClasses(group, indexGroup)">
                    <div class="header">
                        <div class="fa-stack drag" v-if="group.draggable" v-on:mousedown="DragStartBusinessUnit($event, group, indexGroup)">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-stack-2x fa-arrows-alt"></i>
                        </div>
                        <div class="label">{{group.header}}</div>
                        <div class="fa-stack" v-on:click="group.collapsed = !group.collapsed">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-stack-2x" v-bind:class="{'fa-angle-down' : group.collapsed, 'fa-angle-up' : !group.collapsed}"></i>
                        </div>
                    </div>
                    <div class="drag-catch-area"></div>
                    <div class="drag-catch-area last"></div>
                    <div class="row" v-for="(employee, indexE) in group.employees" :key="indexE" v-if="!group.collapsed && EmployeeIsVisible(employee.employee)"
                         v-bind:style="{display: !group.employeesFiltered.find(e => e === employee) ? 'none !important' : ''}">
                        <div class="employee">
                            <div class="picture" v-bind:style="{background: (employee !== null ? employee.picture : 'url(../img/default.jpg)'), 'background-size': 'contain'}"></div>
                            <div class="name">{{employee.name}}</div>
                            <div class="progress">
                                <div class="progress-bar" v-bind:style="{width: ((employee.progressCurrent / employee.progressMax) * 100) + '%'}"></div>
                                <div class="label">{{employee.progressCurrent + '/' + employee.progressMax}}</div>
                            </div>
                            <div class="fa-stack add" v-on:click="OpenNewPreferencePopup($event, employee.employee)">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-plus fa-stack-2x"></i>
                            </div>
                        </div>
                        <div class="timeframe" v-if="(timeFrame.preference.state && filterDropdownOptions.find(o => o.state && o.state.id === timeFrame.preference.state && o.toggled)) || (timeFrame.preference.type && filterDropdownOptions.find(o => o.type && o.type.id === timeFrame.preference.type && o.toggled)) " v-for="(timeFrame, indexF) in employee.timeFrames" :key="indexF" v-bind:style="[GetTimeFrameStyles(timeFrame)]" v-bind:id="timeFrame.preference.id"
                             v-on:mouseup="SelectTimeFrame($event, timeFrame)">
                            <div class="handle start" v-on:mousedown="StartDragTimeFrame($event, timeFrame, true)"><div class="inner"></div></div>
                            <div class="handle end" v-on:mousedown="StartDragTimeFrame($event, timeFrame, false)"><div class="inner"></div></div>
                        </div>
                        <div class="bottom-line"></div>
                    </div>
                </div>
                <div class="time-marks">
                    <div class="mark" v-for="(mark, indexMark) in timeMarks" :key="indexMark" v-bind:style="[GetTimeMarkWidth(indexMark)]">
                        <div class="label">{{displayedTimeframeSelected.label !== 'Y' ? mark : displayedTimeframeSelected.timeStart.clone().month(indexMark).format('MMM')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="event-info" v-if="eventOnHover">
            <div class="header">{{eventOnHover.header}}</div>
            <div class="description">{{eventOnHover.description}}</div>
        </div>
        <div class="drag-info" v-if="dragging">
            <div class="description">{{draggingTime.format('YYYY-MM-DD HHa')}}</div>
        </div>
        <div class="drag-group group" v-if="draggingGroup">
            <div class="header">
                <div class="fa-stack drag">
                    <i class="fas fa-stack-2x fa-arrows-alt"></i>
                </div>
                <div class="label">{{draggingGroup.header}}</div>
                <div class="fa-stack add">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-plus fa-stack-2x"></i>
                </div>
                <div class="fa-stack">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-stack-2x fa-angle-down"></i>
                </div>
            </div>
        </div>
        <div class="timeframe-popup" v-if="selectedTimeFrame" v-bind:style="{'left' : timeFramePopupOffsetX + 'px', 'top' : timeFramePopupOffsetY + 'px'}">
            <div class="background" v-on:click="selectedTimeFrame = null"></div>
            <div class="button" v-if="!selectedTimeFrame.preference.approved" v-on:click="ApproveRequest(selectedTimeFrame.preference)">
                <div class="label">Genehmigen</div>
            </div>
            <div class="button" v-on:click="DeleteRequest(selectedTimeFrame.preference)">
                <div class="label">Löschen</div>
            </div>
        </div>
        <div v-if="loading" class="loading">
            <i class="fas fa-spinner"></i>
        </div>
        <dropdowncontainer ref="dropdowncontainer"/>
        <datepicker :state="datepickerState" ref="pickFrom" v-on:datepicker-date-picked="onDatePicked"></datepicker>
    </div>
</template>

<script>

    import dropdowncontainer from '../uicomponents/dropdowncontainer.vue'
    import datepicker from '../uicomponents/datepicker.vue'
    var moment = require('moment');
    export default {
        name: 'PreferenceView',
        components: {
            dropdowncontainer,
            datepicker
        },
        data(){
            return{
                displayedTimeframes: [],
                displayedTimeframeSelected: null,
                employeeGroups: [],
                eventOnHover: null,
                mouseX: 0,
                mouseY: 0,
                timeMarks: [],
                timeFrameStart: this.$helpers.getMomentUTC().hours(0).minutes(0), //this.$helpers.getMomentUTC().date(14).hours(0).minutes(0), //changing .date here for debugging for now
                timeFrameLength: 24 * 60 * 60 * 1000,
                employees: [],
                employeesFiltered: [],
                employeeMap: {},
                preferences: {},
                businessUnits: [],
                businessUnitsMap: {},
                spots: [],
                spotMap: {},
                uiData: [],
                employeeAvailabilityStateMap: {},
                employeeAvailabilityTypeMap: {},
                filterDropdownOptions: [],
                selectedTimeFrame: null,
                timeFramePopupOffsetY: 0,
                timeFramePopupOffsetX: 0,
                loading: false,
                dragging: false,
                draggingTimeFrame: null,
                draggingStart: false,
                draggingStartPos: {x: 0, y: 0},
                draggingHandle: null,
                draggingGroup: null,
                groupCollapsedStates: {},
                userunitsort: [],
                spotVisibilityList: [],
                skillVisibilityList: [],
                ungroupEmployees: false,
                employeeSkills: {},
                skills: [],
                skillMap: {},
                dateSelectionStart: this.$helpers.getCurrentMonthMomentUTC().hours(0).minutes(0),
                datepickerState: {
                        toggled: false,
                        monthView: true,
                        yearViewAllowed: false,
                        dayViewAllowed: false,
                        posx: window.mouse.x,
                        posy: window.mouse.y,
                        date: this.$helpers.getCurrentMonthMomentUTC(),
                        selectedDate: this.$helpers.getCurrentMonthMomentUTC()
                },
            }
        },
        props:{
            currentDay: Object,
        },
        computed: {
            rosterFromTo() {
                if(this.$store.state.loggedIn){
                    return this.$store.state.rosterFromTo;
                } else {
                    return null;
                }    
            },
            storeId() {
                return this.$store.state.storeId;
            },
            monthDisplay: function() {
                if(this.dateSelectionStart != null){
                    return this.dateSelectionStart.format('MMM YYYY');
                } else {
                    '-';
                }
                    
            },
        },
        watch: {
            rosterFromTo(newVal, oldVal) {
                if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                    this.Init();
                }
            },
            storeId(newVal, oldVal) {
                console.log("Changed storeId: "+newVal);
                this.Init();
            },
            dateSelectionStart(newVal, oldVal){
                if(this.currentDay) this.InitDaily();
                else this.InitMonthly();
            }
        },
        created() {
            if(this.currentDay) this.InitDaily();
            else this.InitMonthly();
            window.employeepreference = this;


        },
        updated(){
            if($(this.$el).find('.group').length > 0)$(this.$el).find('.time-marks').css({'height': ($(this.$el).find('.group').last()[0].getBoundingClientRect().bottom - 50) + 'px'});
        },
        mounted() {
            this.Init();
        },
        beforeDestroy(){

            if(this.$refs.dropdowncontainer && this.$refs.dropdowncontainer.$el) $(this.$refs.dropdowncontainer.$el).remove();
        },
        methods: {
            Init(){
                if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && !this.loading){
                
                    var view = this;
                    this.loading = true;
                    this.employeeGroups = [];

                    let employeePayload = {ids: []};
                    view.loadUIData().then(response=> {
                        view.updateUIData(response.data);
                        return view.loadActiveEmployees();
                    }).then(response => {
                        view.employeeMap = {};
                        view.employees = response.data;
                        view.employees.forEach(e => view.employeeMap[e.id] = e);
                        for (let i = 0; i < response.data.length; i++) {
                            employeePayload.ids.push(response.data[i].id);
                        }
                        return view.loadSkills()
                    }).then(response => {
                        view.skills = response.data;
                        view.skillVisibilityList = [];
                        view.skillMap = {};
                        view.skills.forEach(s => view.skillMap[s.id] = s);
                        return view.loadEmployeeSkills(employeePayload)
                    }).then(response => {
                        view.employeeSkills = response.data;
                        return view.loadEmployeePreferences()
                    }).then(response => {
                        view.preferences = response.data;
                        return  view.loadBusinessUnits()
                    }).then(response => {
                        view.businessUnits = response.data;
                        view.businessUnitsMap = {};
                        view.businessUnits.forEach(b => view.businessUnitsMap[b.id] = b);
                        return view.loadUserUnitSort()
                    }).then(response => {
                        view.updateUserUnitSort(response.data);
                        return view.loadSpots();
                    }).then(response => {
                        view.spots = response.data;
                        view.SortGroupsByPriority();
                        view.SortGroupsByParentUnit();
                        view.spotMap = {};
                        view.spots.forEach(s => view.spotMap[s.id] = s);
                        view.spotVisibilityList = [];
                        view.spots.forEach(s => view.spotVisibilityList.push(s));
                        view.LoadFilterDropdown();
                        view.LoadGroupsBySpots();
                        view.GetTimeMarks();
                        view.loading = false;

                        requestAnimationFrame(function(){
                                view.$forceUpdate();
                        });
                    }).catch(function (error) {
                        view.loading = false;
                        view.$helpers.error('Fehler', 'Fehler beim Laden der Daten');
                        console.log(error)
                    });
                }
                
            },
            toggleDatePicker() {
                this.datepickerState = {
                    toggled: true,
                    monthView: true,
                    yearViewAllowed: false,
                    dayViewAllowed: false,
                    posx: window.mouse.x,
                    posy: window.mouse.y,
                    date: this.dateSelectionStart,
                    selectedDate: this.dateSelectionStart
                };
            },
            setDateSelection(date, calculateRosterFromTo){
                this.dateSelectionStart = date.clone(); 
                        
                if(calculateRosterFromTo){
                    //update vuex store with calculated from to => triggers reload of data via refresh
                    
                    let rosterFromTo = {
                        month: this.dateSelectionStart.month(),
                        from: this.dateSelectionStart.clone().startOf('isoWeek').format(),
                        to: this.dateSelectionStart.clone().endOf('month').endOf('isoWeek').add(1,'weeks').startOf('isoWeek').format(),
                    };
                    this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
                } else {
                    //dont update vuex from to, only update client side view
                }
            },
            onDatePicked(date){        
                this.setDateSelection(date, true);
            },
            GetGroupClasses(group, indexGroup){
                return {
                    'sub-spot': group.spot && !group.spot.isMain,
                    'group-dragged': group === this.draggingGroup,
                    'show-drag-area': this.draggingGroup && this.draggingGroup.spot && group.spot &&                                              // make sure you're dragging and the spots are set
                        ((this.draggingGroup.spot.isMain && group.spot.isMain) ||                                                                 // if you're dragging a main group then the subgroups shouldn't show their drag areas
                        (!this.draggingGroup.spot.isMain && !group.spot.isMain && group.spot.unitId == this.draggingGroup.spot.unitId && group.spot)), // if you're dragging a subgroup then only show the drag areas of the same parent
                    'show-drag-area-last': this.draggingGroup && (indexGroup === this.employeeGroups.length - 1 ||                                     // this is for dragging in front of a group but only the last one should have it
                                                                                                                                                       // but for subgroups we have to get the last subgroup which I'll do by asking if the next one is a main group (wip)
                        (!this.draggingGroup.spot.isMain && this.draggingGroup !== group && group.spot.unitId === this.draggingGroup.spot.unitId && indexGroup + 1 !== this.employeeGroups.length && this.employeeGroups[indexGroup + 1].spot.isMain))}
            },
            DragStartBusinessUnit: function ($event, employeeGroup,indexGroup){
                var view = this;
                setTimeout(function(){
                    if(!window.mouse.click) return;

                    view.groupCollapsedStates = {};
                    view.employeeGroups.forEach(g => view.groupCollapsedStates[g.header] = g.collapsed);

                    for(let x in view.employeeGroups){
                        view.employeeGroups[x].collapsed = true;
                        if(view.employeeGroups[x].spot == null || view.employeeGroups[x].spot.id === employeeGroup.spot.id){
                            view.employeeGroups[x].show = false;
                        }else{
                            view.employeeGroups[x].show = true;
                        }
                    }

                    view.draggingGroup = employeeGroup;
                    view.DragBusinessUnitWatch();
                }, 500);
            },
            DragBusinessUnitWatch(){
                var view = this;
                if($(this.$el).find('.drag-group').length > 0) $(this.$el).find('.drag-group').css({left: (window.mouse.x - ($(this.$el).find('.drag-group')[0].getBoundingClientRect().width * .025)) + 'px', top: (window.mouse.y - ($(this.$el).find('.drag-group')[0].getBoundingClientRect().height * .5)) + 'px'});


                view.$forceUpdate();
                requestAnimationFrame(function(){
                    if(window.mouse.click) view.DragBusinessUnitWatch();
                    else {
                        requestAnimationFrame(function(){
                            view.EndDragBusinessUnit();
                        });
                    }
                });
            },
            EndDragBusinessUnit(){
                var view = this;
                var elementInGroup = $(this.$el).find('.grid > .group .drag-catch-area').toArray().find(e => { //in all the current group drag areas check if the mouse is inside of it
                    var box = e.getBoundingClientRect();
                    return box.left < window.mouse.x && box.right > window.mouse.x && box.top < window.mouse.y && box.bottom > window.mouse.y;
                });
                if(elementInGroup) {
                    var groupDroppedOverIndex = $(elementInGroup).closest('.group').attr('indexgroup');
                    var groupDroppedOver = this.employeeGroups[groupDroppedOverIndex];
                    this.employeeGroups = this.employeeGroups.filter(g => g !== this.draggingGroup);
                    var insertIndexMain = this.employeeGroups.indexOf(groupDroppedOver);
                    if($(elementInGroup).hasClass('last')) insertIndexMain++;
                    this.employeeGroups.splice(insertIndexMain, 0, this.draggingGroup);
                    if(this.draggingGroup.spot.isMain){
                        var subSpotGroups = this.employeeGroups.filter(g => !g.spot.isMain);
                        this.employeeGroups = this.employeeGroups.filter(g => g.spot.isMain);
                        if(subSpotGroups.length > 0) {
                            subSpotGroups = subSpotGroups.reverse();
                            subSpotGroups.forEach(g => {
                                var parent = view.employeeGroups.find(gm => gm.spot.isMain && gm.spot.unitId === g.spot.unitId);
                                var parentIndex = view.employeeGroups.indexOf(parent) + 1;
                                view.employeeGroups.splice(parentIndex, 0, g);
                            });
                        }
                    }
                    var sortData = [];
                    this.employeeGroups.forEach(g => sortData.push({unitId: g.spot.id, priority: view.employeeGroups.indexOf(g)}));
                    this.SendBusinessUnitsPriorityUpdate(sortData);
                }
                this.$forceUpdate();
                requestAnimationFrame(function() {
                    view.draggingGroup = null;
                    for (var x in view.groupCollapsedStates) {
                        var group = view.employeeGroups.find(g => g.header === x);
                        if (group) group.collapsed = view.groupCollapsedStates[x];
                    }
                });
            },
            InitMonthly(){
                this.timeFrameStart = this.dateSelectionStart.clone().date(1).hours(0).minutes(0);
                this.displayedTimeframes = [
                    {label: 'W', length: this.WeeksInMonth(this.timeFrameStart) * 7 * 24 * 60 * 60 * 1000, divisions: this.WeeksInMonth(this.timeFrameStart), timeStart: this.timeFrameStart.clone().date(1)},
                    {label: 'M', length: this.timeFrameStart.daysInMonth() * 24 * 60 * 60 * 1000, divisions: this.timeFrameStart.daysInMonth(), timeStart: this.timeFrameStart.clone().date(1)},
                    {label: 'Y', length: moment().month(11).date(31).dayOfYear() * 24 * 60 * 60 * 1000, divisions: 12, timeStart: this.timeFrameStart.clone().month(0).date(1)}
                ];

                this.timeFrameLength = this.displayedTimeframes[this.displayedTimeframes.length - 2].length;
                this.displayedTimeframeSelected = this.displayedTimeframes[this.displayedTimeframes.length - 2];
            },
            InitDaily(){
                if(this.currentDay) this.timeFrameStart = this.currentDay.clone();
                else this.timeFrameStart = this.dateSelectionStart.clone().hours(0).minutes(0);
                this.displayedTimeframes = [
                    {label: '6', length: 6 * 60 * 60 * 1000, divisions: 6, timeStart: this.timeFrameStart.clone()},
                    {label: '12', length: 12 * 60 * 60 * 1000, divisions: 12, timeStart: this.timeFrameStart.clone()},
                    {label: '24', length: 24 * 60 * 60 * 1000, divisions: 24, timeStart: this.timeFrameStart.clone()}
                ];

                this.timeFrameLength = this.displayedTimeframes[this.displayedTimeframes.length - 1].length;
                this.displayedTimeframeSelected = this.displayedTimeframes[this.displayedTimeframes.length - 1];
            },
            SelectTimeFrame($event, timeFrame){
                if(this.dragging) return;
                if(this.selectedTimeFrame) this.selectedTimeFrame = null;
                if(!this.selectedTimeFrame){
                    this.selectedTimeFrame = timeFrame;
                    var target = $event.currentTarget;
                    var box = $event.currentTarget.getBoundingClientRect();
                    this.timeFramePopupOffsetX = box.left + (box.width * .5) - (80); // last var is width of popup
                    this.timeFramePopupOffsetY = box.top + box.height + 15;

                }
            },
            ApproveRequest(preference){
                let view = this;
                let url = '/api/sec/employeepreference/approve';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference/approve');

                let payload = {id: preference.id, certain: preference.approveCertain, factor: preference.factor};

                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    preference.approved = true;
                    view.selectedTimeFrame = null;
                    view.$forceUpdate();
                }).catch(function (error) {
                    console.log(error)
                })
            },
            DeleteRequest(preference){
                let view = this;
                let url = '/api/sec/employeepreference';

                url = this.$helpers.appendParam("id", preference.id, url, '/api/sec/employeepreference');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');


                this.axios({
                    method: 'delete',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    view.selectedTimeFrame = null;
                    view.preferences = view.preferences.filter(p => p.id !== preference.id);
                    if(!view.ungroupEmployees) view.LoadGroupsBySpots();
                    else view.LoadGroupsAllInOne();
                    view.$forceUpdate();
                }).catch(function (error) {
                })

            },
            EventMouseTrack(){
                if($(window.mouse.element).hasClass('event') || $(window.mouse.element).closest('.event').length > 0){
                    this.mouseX = window.mouse.x;
                    this.mouseY = window.mouse.y + 20;
                    $(this.$el).find('.event-info').css({left: (this.mouseX - ($(this.$el).find('.event-info')[0].getBoundingClientRect().width * .5)) + 'px', top: this.mouseY + 'px'});
                } else {
                    this.eventOnHover = null;
                }

            },
            SortGroupsByPriority(){
                var view = this;
                view.spots.sort(function(a, b){
                    let userunitsortA = view.userunitsort.find(s => s.unitId === a.id);
                    let userunitsortB = view.userunitsort.find(s => s.unitId === b.id);
                    if( userunitsortA != null && userunitsortB != null){
                        return userunitsortA.priority - userunitsortB.priority
                    } else {
                        return a.name.localeCompare(b.name);
                    }
                    
                });
            },
            SortGroupsByParentUnit(){
                var subSpotGroups = this.employeeGroups.filter(g => !g.spot.isMain);
                this.employeeGroups = this.employeeGroups.filter(g => g.spot.isMain);
                if(subSpotGroups.length > 0) {
                    subSpotGroups = subSpotGroups.reverse();
                    subSpotGroups.forEach(g => {
                        var parent = this.employeeGroups.find(gm => gm.spot.isMain && gm.spot.unitId === g.spot.unitId);
                        var parentIndex = this.employeeGroups.indexOf(parent) + 1;
                        this.employeeGroups.splice(parentIndex, 0, g);
                    });
                }
            },
            GetColorForType(typeId){
                if(typeId === 1) return '#e76e13'; //vacation
                if(typeId === 2) return '#e51650'; //sickness
                if(typeId === 3) return '#e5c420'; //holiday
                if(typeId === 4) return '#7e1433'; //miscellaneous
                if(typeId === 4) return '#808080'; //no contract
            },
            GetColorForState(stateId){
                if(stateId === 1) return '#e51650'; //unavailable
                if(stateId === 2) return '#294285'; //only available
                if(stateId === 3) return '#ff1655'; //undesired
                if(stateId === 4) return '#aace27'; //desired
            },
            LoadFilterDropdown(){
                var view = this;
                this.filterDropdownOptions = [];
                view.employeeAvailabilityTypes.forEach(function(type){
                    var option = {label: type.label_de, toggled: true, type: type};
                    option.color = view.GetColorForType(type.id);
                    view.filterDropdownOptions.push(option);
                });
                view.employeeAvailabilityStates.forEach(function(state){
                    var option = {label: state.label_de, toggled: true, state: state};
                    option.color = view.GetColorForState(state.id);

                    view.filterDropdownOptions.push(option);
                });
            },
            StartDragTimeFrame($event, timeFrame, isStart){
                var view = this;
                this.dragging = true;
                this.draggingStart = isStart;
                this.draggingTimeFrame = timeFrame;
                this.draggingTimeInit = isStart ? timeFrame.fromDate.clone() : timeFrame.toDate.clone();
                this.draggingStartPos = {x: window.mouse.x, y: window.mouse.y};
                this.draggingHandle = $event.currentTarget;
                this.DragWatch();
            },
            DragWatch(){
                var view = this;
                var time = view.draggingTime = view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
                var timeLimit = !view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
                if($(this.$el).find('.drag-info').length > 0) $(this.$el).find('.drag-info').css({left: (window.mouse.x - ($(this.$el).find('.drag-info')[0].getBoundingClientRect().width * .5)) + 'px', top: (this.draggingHandle.getBoundingClientRect().top - 45)+ 'px'});
                var totalWidth = $(this.$el).find('.grid').width() - 225;
                var timePixelRatio = totalWidth / this.timeFrameLength;

                var delta = window.mouse.x - this.draggingStartPos.x;
                var deltaTime = this.draggingTimeInit.clone().add(delta / timePixelRatio, 'milliseconds');
                time.year(deltaTime.year());
                time.month(deltaTime.month());
                time.date(deltaTime.date());
                time.hours(deltaTime.hours());
                time.minutes(0);
                time.seconds(0);
                time.milliseconds(0);

                view.$forceUpdate();
                requestAnimationFrame(function(){
                    if(window.mouse.click) view.DragWatch();
                    else {
                        view.dragging = false;
                        requestAnimationFrame(function(){
                            view.EndDragTimeFrame();
                        });
                    }
                });
            },
            EndDragTimeFrame(){
                this.UpdateEmployeePreferenceTime(this.draggingTimeFrame.preference, this.draggingTimeFrame.fromDate, this.draggingTimeFrame.toDate, function(response){console.log(response)});
            },
            LoadGroupsByBusinessUnit(){
                var view = this;
                view.employeeGroups = [];
                //view.employeeGroups.push({header: 'All', collapsed: false, businessUnit: {}, employees: []});
                view.businessUnits.forEach(function(businessUnit){
                    var group = {header: businessUnit.name, collapsed: false, businessUnit: businessUnit, draggable: true};
                    group.employees = [];
                    view.employeeGroups.push(group);
                });
                view.employees.forEach(function(employee){
                    var group = view.employeeGroups.find(g => view.spotMap[employee.spotId] && g.businessUnit.id === view.spotMap[employee.spotId].unitId);
                    var employeeTemp = {name: employee.firstName + ' ' + employee.lastName, employee: employee};
                    employeeTemp.progressCurrent = 15;
                    employeeTemp.progressMax = 25;
                    employeeTemp.picture = view.GetProfilePictureUrl(employee);
                    employeeTemp.timeFrames = [];

                    view.preferences.filter(p => p.employeeId === employee.id).forEach(function(preference){
                        var timeFrame = {preference: preference, fromDate: view.$helpers.getMomentFromStringUTC(preference.from, 'YYYY-MM-DDTHH:mm'), toDate: view.$helpers.getMomentFromStringUTC(preference.to, 'YYYY-MM-DDTHH:mm')};
                        employeeTemp.timeFrames.push(timeFrame);
                    });
                    if(group) {
                        group.employees.push(employeeTemp);
                    }
                    view.employeeGroups[0].employees.push(employeeTemp);
                    employee.displayData = employeeTemp;
                });
                view.employeeGroups.forEach(function(group){
                    group.employees.sort(view.sortEmployeeByName);
                });
                view.employeeGroups.forEach(function(group){
                    group.employeesFiltered = group.employees.slice();
                });
            },
            LoadGroupsBySpots(){
                var view = this;
                var collapseStates = {};
                view.employeeGroups.forEach(g => collapseStates[g.spot.id] = g.collapsed);
                view.employeeGroups = [];
                //view.employeeGroups.push({header: 'All', collapsed: false, businessUnit: {}, employees: []});
                view.spots.forEach(function(spot){
                    var group = {header: spot.name, collapsed: collapseStates[spot.id] ? collapseStates : false, spot: spot, draggable: true, isMain: spot.isMain};
                    group.employees = [];
                    view.employeeGroups.push(group);
                });
                view.employees.forEach(function(employee){
                    var group = view.employeeGroups.find(g => g.spot.id === employee.spotId);
                    var employeeTemp = {name: employee.firstName + ' ' + employee.lastName, employee: employee};
                    employeeTemp.progressCurrent = 15;
                    employeeTemp.progressMax = 25;
                    employeeTemp.picture = view.GetProfilePictureUrl(employee);
                    employeeTemp.timeFrames = [];

                    view.preferences.filter(p => p.employeeId === employee.id).forEach(function(preference){
                        var timeFrame = {preference: preference, fromDate: view.$helpers.getMomentFromStringUTC(preference.from, 'YYYY-MM-DDTHH:mm'), toDate: view.$helpers.getMomentFromStringUTC(preference.to, 'YYYY-MM-DDTHH:mm')};
                        employeeTemp.timeFrames.push(timeFrame);
                    });
                    if(group) {
                        group.employees.push(employeeTemp);
                    }
                    employee.displayData = employeeTemp;
                });
                view.employeeGroups.forEach(function(group){
                    group.employees.sort(view.sortEmployeeByName);
                });
                view.employeeGroups.forEach(function(group){
                    group.employeesFiltered = group.employees.slice();
                });
            },
            LoadGroupsAllInOne(){
                var view = this;
                view.employeeGroups = [];
                //view.employeeGroups.push({header: 'All', collapsed: false, businessUnit: {}, employees: []});
                var group = {header: "Alle Mitarbeiter", collapsed: false};
                group.employees = [];
                view.employeeGroups.push(group);
                view.employees.forEach(function(employee){
                    var employeeTemp = {name: employee.firstName + ' ' + employee.lastName, employee: employee};
                    employeeTemp.progressCurrent = 15;
                    employeeTemp.progressMax = 25;
                    employeeTemp.picture = view.GetProfilePictureUrl(employee);
                    employeeTemp.timeFrames = [];

                    view.preferences.filter(p => p.employeeId === employee.id).forEach(function(preference){
                        var timeFrame = {preference: preference, fromDate: view.$helpers.getMomentFromStringUTC(preference.from, 'YYYY-MM-DDTHH:mm'), toDate: view.$helpers.getMomentFromStringUTC(preference.to, 'YYYY-MM-DDTHH:mm')};
                        employeeTemp.timeFrames.push(timeFrame);
                    });
                    if(group) {
                        group.employees.push(employeeTemp);
                    }
                    employee.displayData = employeeTemp;
                });
                view.employeeGroups.forEach(function(group){
                    group.employees.sort(view.sortEmployeeByName);
                });
                view.employeeGroups.forEach(function(group){
                    group.employeesFiltered = group.employees.slice();
                });
            },
            OpenFilterDropdown($event){
                var view = this;
                var target = $event.currentTarget;
                this.$refs.dropdowncontainer.Init({
                    el: target,
                    elRelative: target,
                    header: null,
                    items: view.filterDropdownOptions,
                    currentComponent: 'list',
                    remainAfterSelect: true,
                    pointerOffset: 15,
                    pointerDirection: 0,
                    iconsLeft: true,
                    onceSelected: function($event, item, dropdown){
                        item.toggled = !item.toggled;
                        if(item.state) item.state.show = item.toggled;
                        if(item.type) item.type.show = item.toggled;
                    },
                });
            },
            ToggleEmployeeSort(val){
                this.ungroupEmployees = val;
                if(val) this.LoadGroupsAllInOne();
                else this.LoadGroupsBySpots();
            },
            ToggleEmployeeSkill(skill){
                if(this.skillVisibilityList.find(s => s === skill)) this.skillVisibilityList = this.skillVisibilityList.filter(s => s !== skill);
                else this.skillVisibilityList.push(skill);
            },
            ToggleAllEmployeeSkill(val){
                if(val) this.skillVisibilityList = [];
            },
            EmployeeIsVisible(employee){
                var view = this;
                return view.skillVisibilityList.length === 0 || view.skillVisibilityList.every(s => view.employeeSkills.find(es => es.employeeId === employee.id && s.id === es.skillId));
            },
            OpenNewPreferencePopup($event, employee, spot){
                var view = this;
                var from = this.$helpers.getMomentUTC().hours(8).minutes(0);

                var to = this.$helpers.getMomentUTC().hours(16).minutes(0);

                var stateItems = [];
                view.employeeAvailabilityStates.forEach(function(state){
                    var option = {label: state.label_de, value: state.id, state: state};
                    stateItems.push(option);
                });

                var typeItems = [];
                view.employeeAvailabilityTypes.forEach(function(type){
                    var option = {label: type.label_de, value: type.id, type: type};
                    typeItems.push(option);
                });

                var dataEntries = [
                    {label: 'Employee Id', key: 'employeeId', hidden: true, type: '', value: employee.id},
                    {label: 'Spot Id', key: 'spotId', hidden: true, type: '', value: spot ? spot.id : null},
                    {label: 'Von Tag', key: 'fromDate', hidden: false, type: 'date', value: from.clone(), year: from.year(), month: from.month() + 1, date: from.date()},
                    {label: 'Von', key: 'from', hidden: false, type: 'timeframe', value: from, hours: from.hours(), minutes: from.minutes()},
                    {label: 'Zu Tag', key: 'toDate', hidden: false, type: 'date', value: to.clone(), year: to.year(), month: to.month()+1, date: to.date()},
                    {label: 'Zu', key: 'to', hidden: false, type: 'timeframe', value: to, hours: to.hours(), minutes: to.minutes()},
                    {label: 'Factor', key: 'factor', hidden: true, type: 'numeric', value: 1},
                    {label: 'Work Value', key: 'workValue', hidden: true, type: 'numeric', value: -1},
                    {label: 'Override Contract', key: 'overrideContract', hidden: true, type: 'bool', value: true},
                    {label: 'Kommentar', key: 'comment', hidden: false, type: 'text', value: '', length: 20},
                    {label: 'Status', key: 'state', hidden: false, type: 'searchbar', value: null, selectMultiple: false, searchbar:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: stateItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                        }},
                    {label: 'Typ', key: 'type', hidden: false, type: 'searchbar', value: null, selectMultiple: false, searchbar:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                        }},
                ];
                var target = $event.currentTarget;
                this.ToggleDataFill($event, {
                    header: 'Add Preference',
                    dataEntries: dataEntries,
                    pointerDirection: 3,
                    elRelative: target,
                    selectCallback: function (preference) {
                        
                        preference.from.year(preference.fromDate.year());
                        preference.from.month(preference.fromDate.month());
                        preference.from.date(preference.fromDate.date());

                        preference.to.year(preference.toDate.year());
                        preference.to.month(preference.toDate.month());
                        preference.to.date(preference.toDate.date());
                        view.createEmployeePreference(preference);
                    }
                });

            },
            ToggleDataFill: function ($event, settings) {
                var box = $event.currentTarget.getBoundingClientRect();
                var target = $event.currentTarget;

                this.$refs.dropdowncontainer.Init({
                    elRelative: settings.elRelative,
                    data: settings.dataEntries,
                    header: settings.header,
                    currentComponent: 'datafill',
                    remainAfterSelect: false,
                    pointerOffset: (settings.pointerOffset && settings.pointerOffset !== 0) ? settings.pointerOffset : 15,
                    pointerDirection: (settings.pointerDirection && settings.pointerDirection !== 0) ? settings.pointerDirection : 0,
                    onceSelected: settings.selectCallback,
                });
            },
            GenerateFilterList(){
                var view = this;
                var list = [
                    {label: 'Sortierung nach Stammbereich', toggled: !view.ungroupEmployees, onceSelected: function($event, item){ view.ToggleEmployeeSort(!item.toggled);}},
                    {label: 'Keine Sortierung nach Stammbereich', toggled: view.skillVisibilityList.length === 0,
                        onceSelected: function($event, item, dropdown){
                            if(view.skillVisibilityList.length !== view.skills.length) {
                                dropdown.items.filter(i => i.skill).forEach(i => i.toggled = true);
                                view.ToggleAllEmployeeSkill(true);
                                dropdown.items = view.GenerateFilterList();
                            } else { }
                        }},
                ];
                this.skills.forEach(s => list.push(
                    {label: s.name + ' (' + view.employees.filter(e => view.EmployeeIsVisible(e) && view.employeeSkills.find(es => es.skillId === s.id && es.employeeId === e.id)).length + ') Mitarbeiter', toggled: (view.skillVisibilityList.find(sv => sv === s)) ? true : false, skill: s, onceSelected: function($event, item, dropdown){
                            dropdown.items[1].toggled = false;
                            view.ToggleEmployeeSkill(item.skill);
                            dropdown.items = view.GenerateFilterList();
                        }, styles: [{'margin-left' : '30px'}]},
                ));
                return list;
            },
            OpenFilterPopup($event){
                var view = this;
                var target = $event.currentTarget;
                var list = this.GenerateFilterList();
                this.$refs.dropdowncontainer.Init({
                    el: target,
                    elRelative: target,
                    items: list,
                    currentComponent: 'list',
                    header: 'Filter Einstellungen',
                    expanded: true,
                    remainAfterSelect: true,
                    pointerOffset: 15,
                    pointerDirection: 3,
                    iconsLeft: true,
                    onceSelected: function($event, item, dropdown){
                        item.toggled = !item.toggled;
                    },
                });
            },
            OpenBusinessUnitFilterDropdown($event){
                var view = this;
                var target = $event.currentTarget;

                var list = [];
                this.spots.forEach(s => list.push({label: s.name, toggled: (view.spotVisibilityList.find(p => s === p)) ? true : false, spot: s,
                    styles: s.isMain ? [] : [{'margin-left' : '30px'}]
                }));
                this.$refs.dropdowncontainer.Init({
                    el: target,
                    elRelative: target,
                    items: list,
                    currentComponent: 'list',
                    header: 'Arbeitsbereiche Ein-/Ausblenden',
                    expanded: true,
                    remainAfterSelect: true,
                    pointerOffset: 15,
                    pointerDirection: 3,
                    iconsLeft: true,
                    onceSelected: function($event, item, dropdown){
                        item.toggled = !item.toggled;
                        if(item.toggled) {
                            if (!item.spot.isMain) {
                                dropdown.items.filter(i => !i.toggled && i.spot.unitId === item.spot.unitId && i.spot.isMain).forEach(i => {
                                    i.toggled = true;
                                    view.spotVisibilityList.push(i.spot);
                                });
                            }
                            view.spotVisibilityList.push(item.spot);
                        }
                        else {
                            view.spotVisibilityList = view.spotVisibilityList.filter(s => s !== item.spot);
                            if (item.spot.isMain) {
                                dropdown.items.filter(i => i.spot.unitId === item.spot.unitId).forEach(i => i.toggled = false);
                                view.spotVisibilityList = view.spotVisibilityList.filter(s => s.unitId !== item.spot.unitId);
                            }
                        }
                    },
                });
            },
            GetTimeMarks(){
                var marks = [];
                for(var x = 0; x < this.displayedTimeframeSelected.divisions; x++){
                    marks.push((x > 9 ? x : '0' + x).toString());
                }

                this.timeMarks = marks;
            },
            GetTimeMarkWidth(index) {
                if(this.displayedTimeframeSelected.label === 'Y') {
                    var lengthYear = this.displayedTimeframeSelected.length;
                    var lengthMonth = this.displayedTimeframeSelected.timeStart.clone().month(index).daysInMonth() * 24 * 60 * 60 * 1000;
                    var widthMonth =  lengthYear / lengthMonth;
                    return {width: ($(this.$el).find('.time-marks').width() / widthMonth) + 'px'};
                }
                return {width: ($(this.$el).find('.time-marks').width() / parseInt(this.displayedTimeframeSelected.divisions)) + 'px'};
            },
            RefreshTimeFrame(displayedTimeframe){
                this.displayedTimeframeSelected = displayedTimeframe;
                this.timeFrameLength = displayedTimeframe.length;
                this.GetTimeMarks();
            },
            GetTimeFrameStyles(timeFrame){
                var totalWidth = $(this.$el).find('.time-marks').width();
                var timePixelRatio = totalWidth / this.timeFrameLength;
                var background = '';
                if(this.filterDropdownOptions.find(o => o.state && o.toggled && timeFrame.preference.state && o.state.id === timeFrame.preference.state)) background = this.GetColorForState(timeFrame.preference.state);
                if(this.filterDropdownOptions.find(o => o.type && o.toggled && timeFrame.preference.type && o.type.id === timeFrame.preference.type)) background = this.GetColorForType(timeFrame.preference.type);
                var styles = {
                    width: (this.TimeDiff(timeFrame.fromDate, timeFrame.toDate) * timePixelRatio) + 'px',
                    left: (this.TimeDiff(this.displayedTimeframeSelected.timeStart, timeFrame.fromDate) * timePixelRatio) + 'px',
                    background: background,
                };
                return styles;
            },
            TimeDiff(a, b){
                return (parseInt(b.format('x'))) - (parseInt(a.format('x')));
            },
            GetProfilePictureUrl(employee){
                if(!employee || !employee.employeePicture || !employee.employeePicture.server) return 'var(--contrast-1) no-repeat center/cover  url(../img/default.jpg)';
                var d = new Date();
                return 'var(--contrast-1) no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+Date.now()+')';
            },
            WeeksInMonth(moment) {
                var temp = moment.clone();

                var first = temp.startOf('month').week();
                var last = temp.endOf('month').week();

                if( first > last) {
                    last = first + last;
                }
                return last - first + 1;
            },
            updateEmployees: function(data) {
                // set employee data
                //console.log(data);
                let overviewA = [];
                var i;
                var roster = this;
                let tEmployeeMap = {};
                for (i = 0; i < data.length; i++) {
                    data[i].shiftsDate = {};
                    data[i].picture = this.GetProfilePictureUrl(data[i]);
                    tEmployeeMap[data[i].id] = data[i];
                    overviewA.push(data[i]);

                }
                this.employeeMap = tEmployeeMap;
                this.employees = overviewA;
                this.employees.sort( this.sortByName );
                //this.employeesFiltered = this.employees.slice();

            },
            sortByName: function(a,b){
                var x = a.firstName + " " + a.lastName;
                var y = b.firstName + " " + b.lastName;
                if ( x.toUpperCase() < y.toUpperCase() ) return -1;
                if ( x.toUpperCase() > y.toUpperCase() ) return 1;
                return 0;
            },
            loadUIData: function(){
                let url = '/api/semi/uidata';
                return this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                });
            },
            updateUIData: function(data){
                this.uiData = data;
                let stateMap =  {};
                let typeMap = {};
                for(let i = 0; i < data.employeeAvailabilityStates.length; i++){
                    let employeeAvailabilityState = data.employeeAvailabilityStates[i];
                    stateMap[employeeAvailabilityState.id] = employeeAvailabilityState;
                    employeeAvailabilityState.show = true;
                }
                for(let i = 0; i < data.employeeAvailabilityTypes.length; i++){
                    let employeeAvailabilityType = data.employeeAvailabilityTypes[i];
                    typeMap[employeeAvailabilityType.id] = employeeAvailabilityType;
                    employeeAvailabilityType.show = true;
                }
                this.employeeAvailabilityStates = data.employeeAvailabilityStates;
                this.employeeAvailabilityTypes = data.employeeAvailabilityTypes;
                this.employeeAvailabilityStateMap = stateMap;
                this.employeeAvailabilityTypeMap = typeMap;
            },
            loadActiveEmployees : function() {
                let url = '/api/sec/employee';
                let params = {
                    storeId: this.$store.state.storeId,
                    //activeAt: this.$store.state.rosterFromTo.from,
                    activeAt: "2019-09-24T00:00:00Z",
                };


                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })

            },
            loadEmployeePreferences : function() {

                let url = '/api/sec/employeepreference';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$store.state.rosterFromTo.from,
                    to: this.$store.state.rosterFromTo.to,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })

            },
            loadEmployeeSkills : function(payload) {
                if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
                    return new Promise((resolve, reject) => {
                        resolve({data:[]});
                    })
                } else {
                    let url = '/api/sec/employeeskill/any/employee';

                    let params = {
                        storeId: this.$store.state.storeId,
                    };

                    return this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    });
                }
            },
            loadBusinessUnits : function() {

                let url = '/api/sec/businessunit';

                let params = {
                    storeId: this.$store.state.storeId,
                };


                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            loadSpots : function() {

                let url = '/api/sec/spot';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            UpdateEmployeePreferenceTime(employeePreference, fromDate, toDate,callbackResponse){
                let view = this;
                let url = '/api/sec/employeepreference';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

                let payload = {
                    storeId: this.$store.state.storeId,
                    id: employeePreference.id,
                    updateFields: []
                };

                let cfrom = this.$helpers.convertDateString(fromDate);
                payload.from = cfrom;
                payload.updateFields.push("from");
                let cto = this.$helpers.convertDateString(toDate);
                payload.to = cto;
                payload.updateFields.push("to");

                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    if(callbackResponse) callbackResponse(response);
                }).catch(function (error) {
                    view.error=true;
                    console.log(error)
                })

            },
            UpdateEmployeePreference: function(employeePreference, employeePreferenceUpdate, callbackResponse) {
                this.error = false;
                let view = this;
                let url = '/api/sec/employeepreference';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

                let payload = {
                    storeId: this.$store.state.storeId,
                    id: this.employeePreferenceId,
                    updateFields: []
                }
                if (employeePreferenceUpdate.fromDate && employeePreferenceUpdate.fromTime) {
                    let ofrom = this.$helpers.convertDateTimeString(employeePreference.fromDate, employeePreference.fromTime);
                    let cfrom = this.$helpers.convertDateTimeString(employeePreferenceUpdate.fromDate, employeePreferenceUpdate.fromTime);
                    if (ofrom != cfrom) {
                        payload.from = cfrom;
                        payload.updateFields.push("from");
                    }
                }
                if (employeePreferenceUpdate.toDate && employeePreferenceUpdate.toTime) {
                    let oto = this.$helpers.convertDateTimeString(employeePreference.toDate, employeePreference.toTime);
                    let cto = this.$helpers.convertDateTimeString(employeePreferenceUpdate.toDate, employeePreferenceUpdate.toTime);
                    if (oto != cto) {
                        payload.to = cto;
                        payload.updateFields.push("to");
                    }
                }
                if(employeePreferenceUpdate.factor && employeePreference.factor != employeePreferenceUpdate.factor){
                    payload.factor = employeePreferenceUpdate.factor;
                    payload.updateFields.push("factor");
                }
                if(employeePreferenceUpdate.spotId && employeePreference.spotId != employeePreferenceUpdate.spotId){
                    payload.spotId = employeePreferenceUpdate.spotId;
                    payload.updateFields.push("spotId");
                }

                if(employeePreferenceUpdate.comment && employeePreference.comment != employeePreferenceUpdate.comment){
                    payload.comment = employeePreferenceUpdate.comment;
                    payload.updateFields.push("comment");
                }

                if(employeePreferenceUpdate.overrideContract && employeePreference.overrideContract != employeePreferenceUpdate.overrideContract){
                    payload.overrideContract = employeePreferenceUpdate.overrideContract;
                    payload.updateFields.push("overrideContract");
                }

                if(employeePreferenceUpdate.state && employeePreference.state != employeePreferenceUpdate.state){
                    payload.state = employeePreferenceUpdate.state;
                    payload.updateFields.push("state");
                    if(payload.state != 1){
                        payload.workValue = null;
                        payload.updateFields.push("workValue");
                        payload.type = null;
                        payload.updateFields.push("type");
                    } else {
                        payload.workValue = employeePreferenceUpdate.workValue;
                        payload.updateFields.push("workValue");
                        payload.type = employeePreferenceUpdate.type;
                        payload.updateFields.push("type");
                    }
                }


                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    if(callbackResponse) callbackResponse();
                }).catch(function (error) {
                    view.error=true;
                    console.log(error)
                })

            },
            approveEmployeePreference: function(preference){
                let view = this;
                let url = '/api/sec/employeepreference/approve';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference/approve');

                let payload = {id: preference.id, certain: preference.approveCertain, factor: preference.factor};

                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    preference.approved = true;

                }).catch(function (error) {
                    console.log(error)
                })

            },
            createEmployeePreference: function(preference){
                let view = this;
                let url = '/api/sec/employeepreference';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

                let payload = {
                    storeId: this.$store.state.storeId,
                    exclusive: true,
                    approved: true,
                };
                payload.factor = preference.factor;
                /*payload.from = this.$helpers.convertDateTimeString(preference.fromDate, preference.fromTime);
                payload.to = this.$helpers.convertDateTimeString(preference.toDate, preference.toTime);*/
                payload.from = this.$helpers.convertDateString(preference.from);
                payload.to = this.$helpers.convertDateString(preference.to);
                if(!this.$helpers.isBlank(preference.employeeId)){
                    payload.employeeId = preference.employeeId
                }
                if(!this.$helpers.isBlank(preference.spotId)){
                    payload.spotId = preference.spotId
                }
                if(!this.$helpers.isBlank(preference.comment)){
                    payload.comment = preference.comment
                }
                payload.state = preference.state;
                if(payload.state != 1){
                    payload.type = null;
                    payload.workValue = null;
                } else {
                    payload.type = preference.type;
                    payload.workValue = preference.workValue;
                }

                payload.overrideContract = preference.overrideContract;

                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.preferences.push(response.data.data);
                    if(!view.ungroupEmployees) view.LoadGroupsBySpots();
                    else view.LoadGroupsAllInOne();

                }).catch(function (error) {
                })
            },
            deleteEmployeePreference: function(evt){
                evt.preventDefault();
                this.error=false;
                let view = this;
                let url = '/api/sec/employeepreference';

                url = this.$helpers.appendParam("id", this.employeePreferenceId, url, '/api/sec/employeepreference');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');


                this.axios({
                    method: 'delete',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    const index = this.employeepreferences.findIndex(employeepreference => employeepreference.id === view.employeePreferenceId)
                    if (~index) {
                        view.employeepreferences.splice(index, 1);
                    }
                    view.deleteEmployeePreferenceFromMap(view.employeePreferenceId);
                    view.hideModal('modal-deleteemployeepreference');
                }).catch(function (error) {
                    view.error=true;
                    console.log(error)
                })

            },
            SendBusinessUnitsPriorityUpdate: function(data){
                let view = this;
                let url = '/api/sec/userunitsortupdate';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/userunitsortupdate');
                let payload = {
                    data: data
                }
                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$helpers.success('Gespeichert', 'Die neue Reihenfolge wurde gespeichert!');
                }).catch(function (error) {
                    view.$helpers.warning('Fehler', 'Speichern fehlgeschlagen!');
                    view.error=true;
                    console.log(error)
                })
            },

            loadUserUnitSort : function() {

                let url = '/api/sec/userunitsort';

                let params = {
                    storeId: this.$store.state.storeId,
                };
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })
            },
            updateUserUnitSort: function(data){
                let userunitsort = []
                for (let i = 0; i < data.length; i++) {
                    userunitsort.push(data[i]);
                }
                this.userunitsort = userunitsort;
            },
            sortByPriorityAndName: function(a,b){
                if ( a.priority < b.priority ) return -1;
                if ( a.priority > b.priority ) return 1;
                if ( a.name.toUpperCase() < b.name.toUpperCase() ) return -1;
                if ( a.name.toUpperCase() > b.name.toUpperCase() ) return 1;
                return 0;
            },
            sortEmployeeByName: function(a,b){
                if ( a.employee.lastName.toUpperCase() < b.employee.lastName.toUpperCase() ) return -1;
                if ( a.employee.firstName.toUpperCase() > b.employee.firstName.toUpperCase() ) return 1;
                return 0;
            },
            loadSkills : function() {

                let url = '/api/sec/skill';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .employee-preference-view{
        position: relative;
    }

    .employee-preference-view > .header{
        background: var(--contrast-1);
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 60px;
        text-align: center;
        z-index: 2;

    }

    .employee-preference-view > .header > *{

        display: inline-block;
        position: relative;
        top: 50%;
        transform: translateY(-50%) !important;
        margin-top: 0 !important;

    }
    .employee-preference-view > .header > .button.filter{

        float: initial;
        display: inline-block;
        margin: 0 10px;
        transform: translateY(1px);

    }

    .options{
        display: inline-block;
        margin-top: 20px;
    }

    .options .label{
        text-align: center;
        border-radius: 5px;
        transition: .2s;
        height: 25px;
        width: 35px;
        border: 1px solid var(--contrast-5);
        border-right: none;
        border-radius: 0;
        line-height: 190%;
        cursor: pointer;
    }
    .options .label:first-child{
        border-radius: 5px 0 0 5px;
    }
    .options .label:last-child{
        border-radius: 0 5px 5px 0;
        border-right: 1px solid var(--contrast-5);
    }
    .options .label.selected, .options .label:hover{
        background: #6c8d25;
        color: white;
    }

    .grid{
        padding-top: 40px;
        text-align: center;
        position: relative;
        height: 100%;
    }

    .grid > .header{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        box-shadow: inset 0 -2px 0 -1px #d5d5d5;
        z-index: 2;
        padding-left: 10px;
    }

    .group{
        margin-bottom: 10px;
    }

    .group > .header{
        width: 230px;
        height: 19px;
        background: #6d8d23;
        border-radius: 50px;
        position: relative;
        z-index: 2;
        margin-left: 5px;
    }

    .group > .header .label{
        color: white;
        font-size: 13px;
        padding-left: 20px;
    }

    .group > .header .fa-stack{
        position: absolute;
        right: -10px;
        transform: scale(0.55);
        top: -4px;
        margin: 0;
        cursor: pointer;
    }


    .group > .header .fa-stack > *{
        pointer-events: none;
    }

    .group > .header .fa-stack.add{
        right: 6px;
    }
    .group > .header .fa-stack *:not(.fa-circle){
        color: #6d8d23;
    }
    .group > .header .fa-stack .fa-circle{
        color: #e5e5e5;
    }
    .group > .header .fa-stack:hover .fa-circle{
        color: #707070 !important;
    }
    .group > .header .fa-stack:hover *:not(.fa-circle):not(.fa-arrows-alt){
        color: #e5e5e5 !important;
    }
    .group > .header .fa-stack.drag{
        right: initial;
        left: -10px;
    }
    .group > .header .fa-stack.drag .fa-arrows-alt{
        line-height: 130%;
        font-size: 20px;
        color: white;
    }

    .group > .header .fa-stack.drag .fa-circle{
        display: none;
    }


    .row{
        position: relative;
        width: calc(100% - 215px);
        padding: 5px;
        margin-left: 260px;
        height: 45px;
    }

    .grid .employee{
        position: absolute;
        top: 0;
        left: -245px;
        height: 46px;
        margin-bottom: 5px;
        padding-left: 45px;
        width: 201px;
        box-shadow: inset 0px -2px 0 -1px var(--contrast-1);
        z-index: 3;
    }

    .grid .row:hover .employee {
        background: var(--contrast-2);
        border-radius: 0;
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
        box-shadow: none;
    }

    .employee .picture {
        background-size: 100%;
        position: absolute;
        height: 30px;
        width: 30px;
        left: 5px;
        top: 7px;
        border-radius: 33px;
    }

    .employee .name {
        font-size: 13px;
        color: var(--contrast-5);
        text-align: left;
        height: 15px;
        white-space: nowrap;
        font-weight: 800;
        margin-top: 5px;
        margin-left: 0px;
        font-family: DistrictProBold;
    }
    .employee .progress {
        position: absolute;
        width: calc(100% - 45px);
        margin: auto;
        top: 30px;
        height: 6px;
        border-radius: 100px;
        background: var(--contrast-6);
        left: 45px;
        overflow: hidden;
    }

    .employee .progress .progress-bar {
        position: absolute;
        width: 00%;
        bottom: 00px;
        height: 100%;
        border-radius: 100px;
        background: var(--contrast-5);
        left: 0;
    }

    .employee .progress .progress-bar{
    }


    .employee .add{
        position:absolute;
        top: -0px;
        right: -5px;
        transform: scale(0.4);
        cursor: pointer;
    }
    .employee .add .fa-plus{
        transform: scale(0.8);
    }


    .event-info, .timeframe-popup, .drag-info, .drag-group{
        position: fixed;
        margin: auto;
        display: inline-block;
        background: var(--bg);
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        opacity: 1;
    }

    .drag-info .description{
        color: var(--contrast-4);
    }

    .drag-group{
        background: none;
        box-shadow: none;
        z-index: 100;
        pointer-events: none;
    }

    .event-info .header{
        position: relative;
        width: 100%;
        font-weight: 600;
        text-align: center;
    }

    .event-info .description{
        position: relative;
        width: 100%;
        text-align: center;
    }
    .timeframe-popup{
        pointer-events: initial;
        z-index: 3;
    }

    .timeframe-popup .button{
        position: relative;
        font-weight: 600;
        text-align: center;
        margin: 5px 15px;
        width: 120px;
        display: block;
        height: 18px;
        border-radius: 100px;
        line-height: 100%;
    }

    .timeframe-popup .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }



    .time-marks{
        pointer-events: none;
        position: absolute;
        left: 260px;
        top: 15px;
        width: calc(100% - 258px);
        height: 100%;
        z-index: -1;
        padding: 0;
        white-space: nowrap;
    }

    .time-marks .label{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        text-align: center;
    }

    .time-marks .mark{
        text-align: center;
        position: relative;
        width: calc(100% / 24);
        height: 100%;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px  var(--contrast-1);
        background: none;
    }

    .timeframe{
        position: absolute;
        height: calc(100% - 10px);
        background: #cccccc;
        z-index: 0;
        border-radius: 5px;
        cursor: pointer;
        min-width: 5px;
    }

    .timeframe .handle{
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 15px;
        margin: auto;
        cursor: col-resize;
        color: #9f9f9f;
        text-align: center;
        transition: .2s;
        opacity: 0;
    }


    .timeframe .handle .inner{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: #9f9f9f;
        width: 2px;
        height: calc(100% - 20px);
        pointer-events: none;
    }

    .timeframe:hover .handle{
        opacity: 1;
    }

    .handle.start{
        left: -12px;

    }

    .handle.end{
        right: -12px;
    }
    .timeframe .handle.end{
    }

    .grid .backdrop{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 230px;
        background: var(--bg);
        -webkit-box-shadow: 0 0 30px  var(--bg);
        box-shadow: 0 0 15px 10px  var(--bg);
        z-index: 2;
        pointer-events: none;
    }

    .scrollbar-container{
        width: 100%;
        overflow-x: hidden;
        padding-top: 40px;
    }
    .loading{
        filter: none !important;
        position:absolute;
        box-sizing:content-box;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100vh);
        background: rgba(0,0,0,.5);
        z-index: 10;
    }
    .loading .fa-spinner{
        position:absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 50px;
        height: 50px;
        font-size: 50px;
        color: var(--contrast-3);
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .row .bottom-line{
        box-shadow: inset 0px 2px 0 -1px  var(--contrast-1);
        height: 1px;
        position: absolute;
        bottom: 0px;
        width: calc(100% + 245px);
        left: -245px;
    }

    .fa-refresh:before{
        content: '\f021';
    }

    .group.show-drag-area:not(.group-dragged){
        padding-top: 20px;
    }
    .group .drag-catch-area{
        display: none;
    }
    .group .drag-catch-area.last{
        display: none;
    }

    .group.show-drag-area:not(.group-dragged) .drag-catch-area{
        display: inline-block;
        width: 230px;
        height: 19px;
        left: 5px;
        margin-top: -45px;
        background: var(--contrast-2);
        border-radius: 50px;
        position: absolute;
        z-index: 5;
    }
    .group .drag-catch-area.last{
        display: none;
    }
    .group.show-drag-area-last
    {
        padding-bottom: 20px;
    }
    .group.show-drag-area-last .drag-catch-area.last{
        display: inline-block;
    }
    .group.show-drag-area:not(.group-dragged) .drag-catch-area.last{
        margin-top: 4px;
    }
    .group.show-drag-area:not(.group-dragged):hover .drag-catch-area{
        box-shadow: inset 0 0 0 1px var(--contrast-2);
        background: none;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged) .drag-catch-area{
        width: 210px;
        left: 25px;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged):hover .drag-catch-area{
        box-shadow: inset 0 0 0 1px var(--contrast-2);
        background: none;
    }

    .group-dragged{
        opacity: .5;
    }

    .group.sub-spot > .header{
        width: 210px;
        margin-left: 25px;
    }

    .group.sub-spot  .employee{
        width: 181px;
        left: -225px;
    }


    .positions-filter, .employee-filter {
        position: absolute;
        top: -25px;
        left: 30px;
        z-index: 3;
    }

    .employee-filter {
        left: 80px;
    }
</style>
